"use client";

export { default as AOSProvider } from "./components/AOSProvider";
export { default as useAOSScope } from "./hooks/useAOSScope";
